<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Invoices
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="table-search"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="invoices"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Invoices..."
          item-key="id"
          no-data-text="No Invoices Found"
          :options.sync="options"
          :item-class="itemRowBackground"
          ref="table">

          <template v-slot:[`item.name`]="{ item }">
            {{ item.first_name + ' ' + item.last_name }}
          </template>

          <template v-slot:[`item.grand_total`]="{ item }">
            {{ formatNumberAmount($numeral, item.grand_total) }}
          </template>

          <template v-slot:[`item.invoice_no`]="{ item }">
            <v-icon
              size="24"
              class="mr-2">
              mdi-receipt-text-check
            </v-icon>
            {{ item.invoice_no }}
          </template>


          <template v-slot:[`item.status`]="{ item }">
            <InvoiceStatus :status="item.status" :small="true" :statuses="statuses"></InvoiceStatus>
          </template>

          <template v-slot:[`item.invoice_date`]="{ item }">
            {{ item.invoice_date | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.due_date`]="{ item }">
            {{ item.due_date | moment("MMM D, YYYY") }}
          </template>
          <template v-slot:[`item.points_redeemed`]="{ item }">
            {{ formatNumberAmount($numeral, item.points_redeemed) }}
          </template>

          <template v-slot:item.action="{ item }">

            <v-tooltip bottom v-if="item.status != $getConstInvoiceStatus('INVOICE_STATUS_CREATED')">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  @click="viewItem(item.id)">
                  mdi-file-document
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>

          </template>
        </v-data-table>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import InvoiceStatus from '@/components/InvoiceStatus.vue'

  export default {
    name: 'ClientInvoiceList',
    data() {
      return {
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        statuses: [],
        invoices: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Invoice No.',
            align: 'start',
            value: 'invoice_no',
            sortable: false,
            width: 180,
          },
          {
            text: 'Ref. No.',
            align: 'start',
            value: 'ref_no',
            sortable: false
          },
          {
            text: 'Bill To',
            align: 'start',
            value: 'bill_to_name',
            sortable: false
          },
          {
            text: 'Invoice Date',
            align: 'start',
            value: 'invoice_date',
            width: 130,
            sortable: false
          },
          {
            text: 'Due Date',
            align: 'start',
            value: 'due_date',
            width: 130,
            sortable: false
          },
          {
            text: 'Points Redeemed',
            align: 'right',
            value: 'points_redeemed',
            sortable: false
          },
          {
            text: 'Amount',
            align: 'right',
            value: 'grand_total',
            sortable: false
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false,
            width: 120,
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false,
            width: 80
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getInvoices()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getInvoices()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      itemRowBackground: function (item) {
         return (item.dued == 1 && item.status != this.$getConstInvoiceStatus('INVOICE_STATUS_PAID')) ? 'red lighten-4' : ''
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?invoice_statuses=true')
          .then(response => {
            this.statuses = response.data.invoice_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'invoice-view', params: { id: id } })
      },
      getInvoices () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }

        if(!this.firstLoad){
          this.$router.push({ name: 'invoices-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get('/invoices?page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.invoices = response.data.invoices

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      this.getDefaultData()
    },
    components: {
      SnackBar,
      InvoiceStatus
    },
  }
</script>
